/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ElementsUserMiniReference,
    ElementsUserMiniReferenceFromJSON,
    ElementsUserMiniReferenceFromJSONTyped,
    ElementsUserMiniReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface RestrictedOneTimeAccessToken
 */
export interface RestrictedOneTimeAccessToken {
    /**
     * 
     * @type {number}
     * @memberof RestrictedOneTimeAccessToken
     */
    id: number;
    /**
     * 
     * @type {boolean}
     * @memberof RestrictedOneTimeAccessToken
     */
    readonly hasPassword: boolean;
    /**
     * 
     * @type {ElementsUserMiniReference}
     * @memberof RestrictedOneTimeAccessToken
     */
    user: ElementsUserMiniReference;
    /**
     * 
     * @type {string}
     * @memberof RestrictedOneTimeAccessToken
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof RestrictedOneTimeAccessToken
     */
    readonly fullUrl: string;
}

export function RestrictedOneTimeAccessTokenFromJSON(json: any): RestrictedOneTimeAccessToken {
    return RestrictedOneTimeAccessTokenFromJSONTyped(json, false);
}

export function RestrictedOneTimeAccessTokenFromJSONTyped(json: any, ignoreDiscriminator: boolean): RestrictedOneTimeAccessToken {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'hasPassword': json['has_password'],
        'user': ElementsUserMiniReferenceFromJSON(json['user']),
        'url': json['url'],
        'fullUrl': json['full_url'],
    };
}

export function RestrictedOneTimeAccessTokenToJSON(value?: RestrictedOneTimeAccessToken | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'user': ElementsUserMiniReferenceToJSON(value.user),
        'url': value.url,
    };
}


